package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Northern Mariana Islands Flag (32x24dp)
 *
 * - ISO Alpha-2: MP
 * - ISO Alpha-3: MNP
 * - ISO Numeric: 580
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.NorthernMarianaIslands: ImageVector by lazy {
    ImageVector.Builder(
        name = "Northern Mariana Islands:MP:MNP:580:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2993EC)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(34f)
                verticalLineTo(24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF1F9FF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.213f, 11.583f)
                curveTo(6.213f, 16.876f, 10.595f, 21.167f, 16f, 21.167f)
                curveTo(21.405f, 21.167f, 25.787f, 16.876f, 25.787f, 11.583f)
                curveTo(25.787f, 6.291f, 21.405f, 2f, 16f, 2f)
                curveTo(10.595f, 2f, 6.213f, 6.291f, 6.213f, 11.583f)
                close()
                moveTo(23.66f, 11.583f)
                curveTo(23.66f, 15.726f, 20.23f, 19.083f, 16f, 19.083f)
                curveTo(11.77f, 19.083f, 8.34f, 15.726f, 8.34f, 11.583f)
                curveTo(8.34f, 7.441f, 11.77f, 4.083f, 16f, 4.083f)
                curveTo(20.23f, 4.083f, 23.66f, 7.441f, 23.66f, 11.583f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE31D1C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.064f, 11.583f)
                curveTo(7.064f, 16.416f, 11.065f, 20.333f, 16f, 20.333f)
                curveTo(20.935f, 20.333f, 24.936f, 16.416f, 24.936f, 11.583f)
                curveTo(24.936f, 6.751f, 20.935f, 2.833f, 16f, 2.833f)
                curveTo(11.065f, 2.833f, 7.064f, 6.751f, 7.064f, 11.583f)
                close()
                moveTo(24.511f, 11.583f)
                curveTo(24.511f, 16.186f, 20.7f, 19.917f, 16f, 19.917f)
                curveTo(11.3f, 19.917f, 7.489f, 16.186f, 7.489f, 11.583f)
                curveTo(7.489f, 6.981f, 11.3f, 3.25f, 16f, 3.25f)
                curveTo(20.7f, 3.25f, 24.511f, 6.981f, 24.511f, 11.583f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFDDA33)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16f, 2.208f)
                curveTo(15.892f, 2.431f, 15.838f, 2.747f, 15.838f, 3.158f)
                curveTo(15.838f, 3.568f, 15.679f, 3.978f, 15.362f, 4.389f)
                curveTo(15.303f, 3.937f, 15.273f, 3.526f, 15.273f, 3.158f)
                curveTo(15.273f, 2.789f, 15.515f, 2.473f, 16f, 2.208f)
                close()
                moveTo(18.236f, 2.547f)
                curveTo(18.081f, 2.74f, 17.957f, 3.036f, 17.865f, 3.435f)
                curveTo(17.773f, 3.835f, 17.526f, 4.199f, 17.124f, 4.529f)
                curveTo(17.168f, 4.074f, 17.232f, 3.668f, 17.315f, 3.308f)
                curveTo(17.397f, 2.949f, 17.705f, 2.695f, 18.236f, 2.547f)
                close()
                moveTo(19.773f, 4.168f)
                curveTo(19.959f, 3.802f, 20.151f, 3.545f, 20.348f, 3.396f)
                curveTo(19.796f, 3.411f, 19.437f, 3.583f, 19.27f, 3.911f)
                curveTo(19.102f, 4.24f, 18.942f, 4.619f, 18.789f, 5.049f)
                curveTo(19.259f, 4.827f, 19.587f, 4.533f, 19.773f, 4.168f)
                close()
                moveTo(22.191f, 4.684f)
                curveTo(21.965f, 4.785f, 21.721f, 4.993f, 21.457f, 5.307f)
                curveTo(21.193f, 5.621f, 20.808f, 5.834f, 20.3f, 5.944f)
                curveTo(20.546f, 5.56f, 20.787f, 5.226f, 21.024f, 4.944f)
                curveTo(21.261f, 4.662f, 21.65f, 4.575f, 22.191f, 4.684f)
                close()
                moveTo(22.828f, 6.796f)
                curveTo(23.156f, 6.549f, 23.441f, 6.402f, 23.683f, 6.354f)
                curveTo(23.181f, 6.126f, 22.782f, 6.123f, 22.488f, 6.345f)
                curveTo(22.194f, 6.567f, 21.883f, 6.837f, 21.557f, 7.157f)
                curveTo(22.077f, 7.163f, 22.5f, 7.043f, 22.828f, 6.796f)
                close()
                moveTo(24.747f, 8.336f)
                curveTo(24.499f, 8.324f, 24.187f, 8.398f, 23.809f, 8.558f)
                curveTo(23.432f, 8.718f, 22.992f, 8.733f, 22.49f, 8.601f)
                curveTo(22.883f, 8.37f, 23.249f, 8.182f, 23.589f, 8.038f)
                curveTo(23.928f, 7.894f, 24.314f, 7.993f, 24.747f, 8.336f)
                close()
                moveTo(24.352f, 10.491f)
                curveTo(24.756f, 10.42f, 25.077f, 10.418f, 25.315f, 10.485f)
                curveTo(24.971f, 10.054f, 24.617f, 9.87f, 24.254f, 9.934f)
                curveTo(23.891f, 9.999f, 23.492f, 10.099f, 23.057f, 10.236f)
                curveTo(23.517f, 10.477f, 23.948f, 10.562f, 24.352f, 10.491f)
                close()
                moveTo(6.084f, 9.77f)
                curveTo(6.285f, 9.915f, 6.587f, 10.023f, 6.991f, 10.094f)
                curveTo(7.395f, 10.165f, 7.771f, 10.393f, 8.121f, 10.777f)
                curveTo(7.665f, 10.757f, 7.256f, 10.714f, 6.893f, 10.65f)
                curveTo(6.53f, 10.586f, 6.26f, 10.293f, 6.084f, 9.77f)
                close()
                moveTo(7.621f, 8.187f)
                curveTo(7.244f, 8.027f, 6.973f, 7.854f, 6.811f, 7.667f)
                curveTo(6.864f, 8.216f, 7.061f, 8.563f, 7.4f, 8.707f)
                curveTo(7.74f, 8.851f, 8.129f, 8.984f, 8.569f, 9.107f)
                curveTo(8.315f, 8.654f, 7.999f, 8.347f, 7.621f, 8.187f)
                close()
                moveTo(8.027f, 5.774f)
                curveTo(8.14f, 5.994f, 8.36f, 6.227f, 8.688f, 6.474f)
                curveTo(9.015f, 6.721f, 9.248f, 7.095f, 9.385f, 7.596f)
                curveTo(8.988f, 7.371f, 8.642f, 7.147f, 8.348f, 6.925f)
                curveTo(8.053f, 6.703f, 7.946f, 6.32f, 8.027f, 5.774f)
                close()
                moveTo(10.125f, 5.048f)
                curveTo(9.861f, 4.734f, 9.699f, 4.457f, 9.639f, 4.217f)
                curveTo(9.437f, 4.731f, 9.455f, 5.129f, 9.692f, 5.411f)
                curveTo(9.929f, 5.694f, 10.216f, 5.989f, 10.552f, 6.298f)
                curveTo(10.531f, 5.779f, 10.389f, 5.362f, 10.125f, 5.048f)
                close()
                moveTo(11.573f, 3.066f)
                curveTo(11.578f, 3.313f, 11.673f, 3.619f, 11.859f, 3.985f)
                curveTo(12.046f, 4.35f, 12.09f, 4.788f, 11.994f, 5.299f)
                curveTo(11.736f, 4.922f, 11.523f, 4.57f, 11.356f, 4.241f)
                curveTo(11.189f, 3.913f, 11.261f, 3.521f, 11.573f, 3.066f)
                close()
                moveTo(13.801f, 3.345f)
                curveTo(13.709f, 2.945f, 13.69f, 2.625f, 13.745f, 2.383f)
                curveTo(13.332f, 2.75f, 13.167f, 3.113f, 13.25f, 3.472f)
                curveTo(13.333f, 3.831f, 13.455f, 4.225f, 13.614f, 4.652f)
                curveTo(13.831f, 4.18f, 13.893f, 3.744f, 13.801f, 3.345f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFA7A7A7)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.586f, 5.75f)
                curveTo(14.219f, 5.75f, 13.947f, 6.089f, 14.025f, 6.447f)
                lineTo(14.412f, 8.215f)
                curveTo(14.446f, 8.37f, 14.541f, 8.499f, 14.668f, 8.579f)
                curveTo(14.551f, 8.671f, 14.469f, 8.807f, 14.45f, 8.965f)
                lineTo(13.063f, 20.61f)
                curveTo(13.037f, 20.824f, 13.133f, 21.033f, 13.32f, 21.14f)
                curveTo(13.842f, 21.439f, 14.974f, 22f, 16.106f, 22f)
                curveTo(17.239f, 22f, 18.371f, 21.439f, 18.893f, 21.14f)
                curveTo(19.08f, 21.033f, 19.176f, 20.824f, 19.15f, 20.61f)
                lineTo(17.763f, 8.965f)
                curveTo(17.744f, 8.807f, 17.662f, 8.671f, 17.545f, 8.579f)
                curveTo(17.672f, 8.499f, 17.767f, 8.37f, 17.801f, 8.215f)
                lineTo(18.188f, 6.447f)
                curveTo(18.266f, 6.089f, 17.993f, 5.75f, 17.627f, 5.75f)
                horizontalLineTo(14.586f)
                close()
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(6.519f, 12.013f)
                curveTo(6.571f, 11.848f, 6.749f, 11.755f, 6.918f, 11.805f)
                curveTo(7.086f, 11.856f, 7.181f, 12.031f, 7.13f, 12.196f)
                curveTo(7.04f, 12.481f, 7.04f, 12.903f, 7.139f, 13.455f)
                curveTo(7.177f, 13.666f, 7.221f, 13.83f, 7.277f, 13.974f)
                curveTo(7.299f, 14.032f, 7.321f, 14.084f, 7.352f, 14.15f)
                curveTo(7.338f, 14.121f, 7.412f, 14.278f, 7.431f, 14.319f)
                curveTo(7.526f, 14.535f, 7.568f, 14.724f, 7.568f, 15.001f)
                curveTo(7.568f, 15.174f, 7.425f, 15.314f, 7.249f, 15.314f)
                curveTo(7.073f, 15.314f, 6.93f, 15.174f, 6.93f, 15.001f)
                curveTo(6.93f, 14.812f, 6.906f, 14.707f, 6.845f, 14.567f)
                curveTo(6.83f, 14.534f, 6.761f, 14.387f, 6.771f, 14.409f)
                curveTo(6.735f, 14.331f, 6.707f, 14.266f, 6.679f, 14.193f)
                curveTo(6.61f, 14.012f, 6.555f, 13.811f, 6.51f, 13.562f)
                curveTo(6.396f, 12.922f, 6.396f, 12.408f, 6.519f, 12.013f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.213f, 16.179f)
                lineTo(12.098f, 18.983f)
                lineTo(13.55f, 14.285f)
                lineTo(9.555f, 11.319f)
                lineTo(14.567f, 11.219f)
                lineTo(16.213f, 6.583f)
                lineTo(17.859f, 11.219f)
                lineTo(22.87f, 11.319f)
                lineTo(18.876f, 14.285f)
                lineTo(20.327f, 18.983f)
                lineTo(16.213f, 16.179f)
                close()
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(25.559f, 12.429f)
                curveTo(25.508f, 12.264f, 25.329f, 12.172f, 25.161f, 12.222f)
                curveTo(24.992f, 12.273f, 24.897f, 12.447f, 24.949f, 12.612f)
                curveTo(25.038f, 12.898f, 25.038f, 13.32f, 24.94f, 13.871f)
                curveTo(24.902f, 14.083f, 24.857f, 14.247f, 24.802f, 14.391f)
                curveTo(24.78f, 14.448f, 24.757f, 14.501f, 24.727f, 14.566f)
                curveTo(24.74f, 14.537f, 24.666f, 14.695f, 24.648f, 14.736f)
                curveTo(24.553f, 14.951f, 24.511f, 15.141f, 24.511f, 15.418f)
                curveTo(24.511f, 15.59f, 24.653f, 15.73f, 24.83f, 15.73f)
                curveTo(25.006f, 15.73f, 25.149f, 15.59f, 25.149f, 15.418f)
                curveTo(25.149f, 15.229f, 25.172f, 15.123f, 25.234f, 14.984f)
                curveTo(25.249f, 14.951f, 25.318f, 14.804f, 25.308f, 14.825f)
                curveTo(25.344f, 14.748f, 25.372f, 14.683f, 25.4f, 14.61f)
                curveTo(25.469f, 14.429f, 25.524f, 14.228f, 25.569f, 13.979f)
                curveTo(25.683f, 13.339f, 25.683f, 12.824f, 25.559f, 12.429f)
                close()
            }
            path(
                stroke = SolidColor(Color(0xFF73BE4A)),
                strokeLineWidth = 1f,
                strokeLineCap = StrokeCap.Round,
                strokeLineJoin = StrokeJoin.Round
            ) {
                moveTo(16.061f, 3.148f)
                curveTo(16.061f, 3.148f, 17.225f, 3.666f, 16.722f, 4.483f)
            }
            path(
                stroke = SolidColor(Color(0xFF73BE4A)),
                strokeLineWidth = 1f,
                strokeLineCap = StrokeCap.Round,
                strokeLineJoin = StrokeJoin.Round
            ) {
                moveTo(16.912f, 3.148f)
                curveTo(16.912f, 3.148f, 18.076f, 3.666f, 17.573f, 4.483f)
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(9.26f, 6.357f)
                curveTo(9.344f, 6.211f, 9.522f, 6.167f, 9.656f, 6.258f)
                curveTo(9.79f, 6.35f, 9.831f, 6.543f, 9.746f, 6.689f)
                curveTo(9.584f, 6.97f, 9.5f, 7.354f, 9.5f, 7.848f)
                curveTo(9.5f, 8.02f, 9.371f, 8.16f, 9.213f, 8.16f)
                curveTo(9.054f, 8.16f, 8.925f, 8.02f, 8.925f, 7.848f)
                curveTo(8.925f, 7.245f, 9.035f, 6.746f, 9.26f, 6.357f)
                close()
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(8.808f, 9.213f)
                curveTo(8.808f, 9.385f, 8.68f, 9.525f, 8.521f, 9.525f)
                curveTo(8.363f, 9.525f, 8.234f, 9.385f, 8.234f, 9.213f)
                verticalLineTo(8.322f)
                curveTo(8.234f, 7.693f, 8.333f, 7.196f, 8.541f, 6.834f)
                curveTo(8.625f, 6.688f, 8.803f, 6.644f, 8.937f, 6.735f)
                curveTo(9.071f, 6.827f, 9.112f, 7.019f, 9.028f, 7.166f)
                curveTo(8.885f, 7.414f, 8.808f, 7.8f, 8.808f, 8.322f)
                verticalLineTo(9.213f)
                close()
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(23.484f, 8.796f)
                curveTo(23.484f, 8.968f, 23.613f, 9.108f, 23.771f, 9.108f)
                curveTo(23.93f, 9.108f, 24.059f, 8.968f, 24.059f, 8.796f)
                verticalLineTo(7.906f)
                curveTo(24.059f, 7.276f, 23.96f, 6.78f, 23.751f, 6.418f)
                curveTo(23.667f, 6.271f, 23.49f, 6.227f, 23.356f, 6.318f)
                curveTo(23.221f, 6.41f, 23.18f, 6.603f, 23.264f, 6.749f)
                curveTo(23.407f, 6.997f, 23.484f, 7.383f, 23.484f, 7.906f)
                verticalLineTo(8.796f)
                close()
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(24.335f, 10.254f)
                curveTo(24.335f, 10.427f, 24.464f, 10.567f, 24.622f, 10.567f)
                curveTo(24.781f, 10.567f, 24.91f, 10.427f, 24.91f, 10.254f)
                verticalLineTo(9.364f)
                curveTo(24.91f, 8.734f, 24.811f, 8.238f, 24.603f, 7.876f)
                curveTo(24.518f, 7.73f, 24.341f, 7.685f, 24.207f, 7.777f)
                curveTo(24.072f, 7.868f, 24.031f, 8.061f, 24.115f, 8.207f)
                curveTo(24.258f, 8.456f, 24.335f, 8.841f, 24.335f, 9.364f)
                verticalLineTo(10.254f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun NorthernMarianaIslandsPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.NorthernMarianaIslands,
            contentDescription = "Northern Mariana Islands Flag"
        )
    }
}
